import React, { useEffect, useState } from 'react';

/** The urgency window loops every 15 minutes and the offer day flips at midnight. */
const WINDOW_MINUTES = 15;
interface OfferState {
  weekday: string;
  minutes: string;
  seconds: string;
}
function getOfferState(): OfferState {
  const now = new Date();
  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0);
  const secondsToday = Math.floor((now.getTime() - startOfDay.getTime()) / 1000);
  const windowSeconds = WINDOW_MINUTES * 60;
  const remaining = windowSeconds - secondsToday % windowSeconds;
  return {
    weekday: new Intl.DateTimeFormat('en-US', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    minutes: String(Math.floor(remaining / 60)).padStart(2, '0'),
    seconds: String(remaining % 60).padStart(2, '0')
  };
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[76px] flex-col items-center" data-id="element-209" data-mp="2emehviufx3xo">
      <span className="font-serif-display text-[52px] font-bold leading-none text-yellow sm:text-6xl" data-id="element-210" data-mp="j6l52badb7vt">
        {value}
      </span>
      <span className="mt-2 text-[10px] font-bold tracking-[0.18em] text-white/55" data-id="element-211" data-mp="e6p1gd5l1igs">{label}</span>
    </div>;
}
export function TodayOfferCard() {
  const [offer, setOffer] = useState<OfferState>(getOfferState);
  useEffect(() => {
    const timer = window.setInterval(() => setOffer(getOfferState()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Today's offer" className="mt-4 overflow-hidden rounded-2xl bg-navy px-5 py-8 text-center text-white shadow-[0_18px_36px_-20px_rgba(17,35,63,0.8)] sm:px-8 sm:py-10" data-id="element-212" data-mp="3rn6h60yaqh35">
      <p className="text-sm font-extrabold tracking-[0.06em] sm:text-base" data-id="element-213" data-mp="4hoykinym2xb">
        <span aria-hidden="true" data-id="element-214" data-mp="3cxh2d2xa6eke">⏰</span> OFFER VALID TODAY ONLY{' '}
        <span className="text-yellow" data-id="element-215" data-mp="3cvntri33xk9r">{offer.weekday}</span>
      </p>

      <div className="mt-6 flex items-start justify-center gap-3" role="timer" aria-live="off" data-id="element-216" data-mp="37xw2mqaae26m">
        <TimeUnit value={offer.minutes} label="MIN" data-id="element-217" data-mp="1buhihfaqz0n7" />
        <span className="flex flex-col items-center gap-2 pt-5" aria-hidden="true" data-id="element-218" data-mp="1gum23e6ycbhn">
          <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-219" data-mp="1gs9bydr1iuti" />
          <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-220" data-mp="1lmner1818487" />
        </span>
        <TimeUnit value={offer.seconds} label="SEC" data-id="element-221" data-mp="1qjdqjcct0dnt" />
      </div>

      <p className="mt-7 text-sm font-extrabold tracking-[0.06em] text-yellow sm:text-base" data-id="element-222" data-mp="swn6csebo90l">
        SPECIAL LAUNCH OFFER
      </p>
      <p className="mt-1.5 text-sm font-bold text-white sm:text-base" data-id="element-223" data-mp="xwszye45k5lb">
        The launch price is available for a limited time.
      </p>

      <div className="mx-auto mt-7 max-w-sm" data-id="element-224" data-mp="12wxisasj9cep">
        <div className="flex items-center justify-between gap-3" data-id="element-225" data-mp="16wxydyrdbtnc">
          <span className="flex items-center gap-2 text-[10px] font-bold tracking-[0.12em] text-white/70" data-id="element-226" data-mp="16u3dy78cu8tx">
            <span className="h-1.5 w-1.5 rounded-full bg-yellow" aria-hidden="true" data-id="element-227" data-mp="2ibl6eakhjm15" />
            SPOTS AT THE LAUNCH PRICE
          </span>
          <span className="text-[10px] font-bold tracking-[0.12em] text-white/85" data-id="element-228" data-mp="6n6lj3e87rkc">
            ALMOST GONE
          </span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Spots taken at the launch price" data-id="element-229" data-mp="2or1n8dfyzb5">
          <div className="h-full w-[68%] rounded-full bg-yellow" data-id="element-230" data-mp="3k4pff4j95ssn" />
        </div>
        <p className="mt-2 text-[10px] font-bold tracking-[0.12em] text-white/55" data-id="element-231" data-mp="3f302fjcgz51x">
          68% OF SPOTS TAKEN
        </p>
      </div>

      <p className="mx-auto mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs text-white/85" data-id="element-232" data-mp="3b2pu4017g2jw">
        <span className="h-2 w-2 rounded-full bg-teal" aria-hidden="true" data-id="element-233" data-mp="19b315sxr5xks" />
        <span aria-hidden="true" data-id="element-234" data-mp="1990enivt6mkt">👀</span>
        <span data-id="element-235" data-mp="14bgq9q5ectf5">
          <strong className="font-bold text-white" data-id="element-236" data-mp="14d1k1djw08by">18 people</strong> viewing right now
        </span>
      </p>
    </aside>;
}